const queryMap = {
  tab: 't',
  eid: 'ei',
  etype: 'et',
  uid: 'u',
  contact: 'c',
  type: 'ty',
  filter: 'f',
  folder: 'fo',
  lead: 'l',
  template: 'tm',
  modal: 'm',
  view: 'v',
  todoId: 'ti',
  noteId: 'ni',
  replyTo: 'rt',
  pipelineStageId: 'psi',
  pipelineLeadId: 'pli',
  creatingLead: 'cl',
  creatingMessageId: 'cmi',
  statusId: 'si',
  contactId: 'ci',
  creating: 'cr',
  contactDetailId: 'cdi',
  notificationFolderId: 'nt',
  integrationAction: 'ia',
  burstActionId: 'bai',
  actionPipelineLeadId: 'apli',
};

export const invertedQueryMap = Object.fromEntries(Object.entries(queryMap).map((n) => [n[1], n[0]]));

export default queryMap;
